"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLTableColElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLTableColElementImpl
};
